import superagent from 'superagent'

// ====== PromoCode/GetStoreCode ======
export const fetchGetStoreCode = () => (dispatch, getState, token) => {
    return new Promise((resolve, reject) => {
        superagent
            .get(`${__API_URI__}/PromoCode/GetStoreCode`)
            .set("Content-Type", "application/json")
            .set("Authorization", `Bearer ${token}`)
            .set("Platform", "Web")
            .set("Version", `${__version__}`)
            .end((err, res) => {
                if (res) {
                    resolve(res.body);
                } else {
                    reject(err);
                }
            });
    });
};
